import { CollectionSurveyQuestions } from '@src/generated/hooks';
import { emailValidation } from '../utils/email';
import { getErrorMessage } from '../utils/validation';

export const validateEmail = (
  question: CollectionSurveyQuestions,
  answer?: string
): string => {
  const { required, type } = question;

  if (type !== 'email') throw new Error('Invalid question type');

  // Not required and no value to validate
  if (!required && !answer) return '';

  // Custom validation rules to account for typo's
  const isValid = emailValidation(answer);

  return isValid ? '' : getErrorMessage(question);
};
